import { createActionTypes, createAsyncActionTypes } from "@dpdgroupuk/redux-action-creator";
const ACTION_NAMESPACE = "APP";
export const ACTIONS = createActionTypes(ACTION_NAMESPACE, {
  CLEAR: "CLEAR",
  FETCH_APP_USER: createAsyncActionTypes("FETCH_APP_USER")
});